import {
  FETCH_ENTITLEMENT_REQUEST,
  FETCH_ENTITLEMENT_SUCCESS,
  FETCH_ENTITLEMENT_FAILURE,
  UPDATE_ENTITLEMENT,
  CLEAR_ENTITLEMENT,
} from '../actions/entitlementActions';

const initialState = {
  loading: false,
  error: null,
  entitlement: null,
  displayName: null,
  subscriptionTier: null,
  billingInterval: null,
  subscriptionStatus: null,
  trialEnd: null,
  nextPaymentDate: null,
  invoicePayment: false,
  subscriptionEnd: null,
  cancelAtPeriodEnd: false,
  // null until a response says: the billing page treats a boolean as the
  // server's answer and otherwise reads the user doc itself.
  promoWaiver: null,
  promoUntil: null,
  // `entitlement` is the effective one. ownEntitlement is the account's own
  // plan (what the subscription fields describe), entitlementSource says
  // where the effective one comes from ('own', 'coach', 'promo', 'admin',
  // 'stripe'), and coverage names the coach, team and plan that include
  // Premium for an athlete (null when none). null until a response says.
  ownEntitlement: null,
  entitlementSource: null,
  coverage: null,
};

const entitlementReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ENTITLEMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ENTITLEMENT_SUCCESS:
    case UPDATE_ENTITLEMENT:
      return {
        ...state,
        loading: false,
        error: null,
        entitlement: action.payload.entitlement,
        displayName: action.payload.displayName,
        subscriptionTier: action.payload.subscriptionTier,
        billingInterval: action.payload.billingInterval,
        subscriptionStatus: action.payload.subscriptionStatus,
        trialEnd: action.payload.trialEnd,
        nextPaymentDate: action.payload.nextPaymentDate,
        invoicePayment: action.payload.invoicePayment || false,
        subscriptionEnd: action.payload.subscriptionEnd,
        cancelAtPeriodEnd: !!action.payload.cancelAtPeriodEnd,
        promoWaiver: typeof action.payload.promoWaiver === 'boolean' ? action.payload.promoWaiver : null,
        promoUntil: action.payload.promoUntil ?? null,
        ownEntitlement: action.payload.ownEntitlement ?? null,
        entitlementSource: action.payload.entitlementSource ?? null,
        coverage: action.payload.coverage && typeof action.payload.coverage === 'object' ? action.payload.coverage : null,
      };

    case FETCH_ENTITLEMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ENTITLEMENT:
      return initialState;

    default:
      return state;
  }
};

export default entitlementReducer;
